export type AppId = string;
export type DateString = string;
export type Url = string;
export type Timezone = string;
export type Currency = string;
export type Milliseconds = number;
export type IpAddress = string;
export type Domain = string;
export type ApiCmpValue = 'cookie_information' | 'piwik' | null;
export type ConsentManagementTool = 'CookieInformationCMP' | 'PiwikLegacy' | 'OtherConsentTool';
export type GdprDataAnonymizationMode = 'session_cookie_id' | 'no_device_storage';

export interface AppAttributes {
  organization: string
  appType: 'web' | 'sharepoint'| 'demo'
  addedAt: DateString
  name: string
  urls: Url[]
  timezone: Timezone
  currency: Currency
  excludeUnknownUrls: boolean
  keepUrlFragment: boolean
  eCommerceTracking: boolean
  sharepointIntegration: boolean
  realTimeDashboards: boolean
  siteSearchQueryParams: string[]
  siteSearchCategoryParams: string[]
  delay: Milliseconds
  excludedIps: IpAddress[]
  excludedUrlParams: string[]
  excludedUserAgents: string[]
  gdpr: boolean
  gdprUserModeEnabled: boolean
  privacyCookieDomainsEnabled: boolean
  privacyCookieExpirationPeriod: Milliseconds
  privacyCookieDomains: Domain[]
  // @deprecated
  gdprLocationRecognition: boolean
  gdprDataAnonymization: boolean
  sessionIdStrictPrivacyMode: boolean
  privacyUseCookies: boolean
  privacyUseFingerprinting: boolean
  cnil: boolean
  gdprDataAnonymizationMode: GdprDataAnonymizationMode
  cmp: ApiCmpValue
}

export interface App {
  id: AppId
  type: 'ppms/app'
  attributes: AppAttributes
}

export interface DetailsResponse<Model> {
  data: Model
}

export interface CollectionResponse<Model> {
  data: Model[]
  meta: {
    total: number
  }
}

export enum SortDirection {
  ASC = '-',
  DESC = ''
}

export type AppsSortByOptions = 'name' | 'addedAt' | 'updatedAt' | '-name' | '-addedAt' | '-updatedAt'

export interface SortOption {
  by: AppsSortByOptions
  direction: SortDirection
}

export interface CreateResponse<Model> extends DetailsResponse<Model> {}

export type AppType = 'website' | 'mobile-app';
